import i from "@metamask/detect-provider";
import { WalletType as r } from "../../../constants/web3.js";
import e from "./Web3Instance.js";
import { saveProvider as s, cleanProvider as l } from "../../../util/authenication/index.js";
import u from "web3";
class n {
  // Since Metamask is able to auto login when the user first
  // enter the page, so Metamask will be used as the default
  // web3 provider
  static async setDefaultProvider(t) {
    if (!e.currentProvider && e.walletType === r.Metamask) {
      const a = await i({
        mustBeMetaMask: !1
      });
      if (a) {
        if (a !== t.ethereum) {
          console.error("Do you have multiple wallets installed?");
          return;
        }
        e.currentProvider = a, e.currentWeb3 = new u(t.ethereum), e.currentProvider.request({
          method: "eth_accounts"
        }).catch((o) => {
          console.error(o);
        });
        const c = await e.getAccount();
        e.currentActiveAccount = c.length ? c[0] : "", e.currentProvider.on("accountsChanged", n.handleAccountsChanged), e.currentProvider.on("chainChanged", n.handleChainChanged), s(r.Metamask);
      } else
        console.error("Please install MetaMask!");
    }
  }
  static detectMetamask() {
    var t;
    return !!((t = window == null ? void 0 : window.ethereum) != null && t.isMetaMask);
  }
  static async requestLogin() {
    if (!e.currentProvider || e.walletType !== r.Metamask && e.walletType !== r.None)
      return;
    const t = await e.currentProvider.request({
      method: "eth_requestAccounts"
    }).catch((a) => {
      console.error(a);
    });
    return e.walletType === r.Metamask && (e.currentActiveAccount = t ? t[0] : ""), e.currentActiveAccount;
  }
  static async handleChainChanged() {
    e.walletType === r.Metamask && await e.updateInfo();
  }
  // For now, 'eth_accounts' will continue to always return an array
  static async handleAccountsChanged(t) {
    e.walletType === r.Metamask && (t.length === 0 ? (e.currentActiveAccount = "", console.error("Please connect to MetaMask.")) : t[0] !== e.currentActiveAccount && (e.currentActiveAccount = t[0]), await e.updateInfo());
  }
  static async handleAllAccountDisconnect() {
    e.walletType === r.Metamask && (e.currentActiveAccount = "", await e.updateInfo(), e.currentProvider = null, e.currentWeb3 = null, e.walletType = r.None, l());
  }
}
export {
  n as default
};
//# sourceMappingURL=Metamask.js.map
